module.exports = __webpack_public_path__ + "img/productVibration_6.6aef2265.png";